import React, { Component } from 'react';

import MainComponent from './comps/MainComponent';
import './App.css';
import { Map, List, Record } from 'immutable';
import { Fragment } from 'react';
import {
  Container, Row, Col, Navbar, NavbarBrand, Nav, NavItem, NavLink, Card, CardBody, CardTitle, CardSubtitle, CardText, Button
} from 'reactstrap';

const isMock = process.env.REACT_APP_MOCK === '1';

// Only load Amplify/auth when not in mock mode to avoid Cognito network calls
if (!isMock) {
  const { Amplify } = require('aws-amplify');
  const awsconfig = require('./comps/auth/auth/awsconfig').default;
  Amplify.configure(awsconfig);
}

const urls = {
  prod: process.env.REACT_APP_RECO_PATH,
  stag: process.env.REACT_APP_RECO_PATH_STAG,
  qa: process.env.REACT_APP_RECO_PATH_QA,
  dev: process.env.REACT_APP_RECO_PATH_DEV,
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        stage: 'prod',
      },
    };
  }

  setStage = (stage) => {
    this.setState({
      data: {
        stage: stage,
      },
    });
  };

  componentDidMount() {}

  render() {
    const { data } = this.state;
    return (
      <MainComponent cognito={this.props} stage={data.stage} setStage={this.setStage} urls={urls}></MainComponent>
    );
  }
}

// MOCK MODE: inject a stub user so no Cognito login is required.
// The stub matches the shape all pages expect:
//   this.props.cognito.user.signInUserSession.idToken.jwtToken
//   this.props.cognito.signOut
const MOCK_COGNITO_STUB = {
  user: {
    signInUserSession: {
      idToken: {
        jwtToken: 'mock-token',
      },
    },
  },
  signOut: () => {},
};

let AppExport;
if (isMock) {
  // Render App directly with stub props — no Amplify, no login screen
  AppExport = function MockApp() {
    return <App {...MOCK_COGNITO_STUB} />;
  };
} else {
  const { withAuthenticator } = require('@aws-amplify/ui-react');
  require('@aws-amplify/ui-react/styles.css');
  const { formFields, services } = require('./comps/auth/theme/settings');
  // Real-login mode: native Cognito email/password sign-in only.
  // No Google/federated social providers (the new fashionsnap-stag-users pool
  // has no hosted UI / identity providers configured).
  //
  // IMPORTANT: do NOT pass the custom `components` from settings.js. Its
  // SignIn.Footer / SignUp.Footer slots call useAuthenticator(), which throws
  // "useAuthenticator must be used inside an Authenticator.Provider" under this
  // Amplify version combo (aws-amplify@4 + @aws-amplify/ui-react@3.6.1) and
  // renders a blank login page. Falling back to the default Amplify UI fixes it.
  // formFields/services are plain config (no hooks) and are safe to keep.
  AppExport = withAuthenticator(App, {
    hideSignUp: true,
    services: services,
    formFields: formFields,
  });
}

export default AppExport;
